<template>
    <div class="publicViewClass" >
        <div class="preview-content" >
            <div class="" :class="$util.isMobile() ? 'new-content-panel1' : ''" class="new-content-panel">
                <div  v-if="isShow == 1" :class="$util.isMobile() ? 'new-content-panel1' : ''" class="new-content-panel">
                <div class="title">
                    <img :src="ExamPreviewInfo.logo" alt="">
                </div>
                <div class="brand-info">
                    <div class="new-exam-title">
                        {{ExamPreviewInfo.paperName}}
                    </div>
                    <h4 v-if="ExamPreviewInfo.showGuidelines !=0">考试说明</h4>
                    <div class="user-introduce" v-html="ExamPreviewInfo.guidelines" v-if="ExamPreviewInfo.showGuidelines ==2 || ExamPreviewInfo.showGuidelines ==3">
                        
                    </div>
                </div>
                <ul class="system-introduce" v-if="ExamPreviewInfo.showGuidelines ==1 || ExamPreviewInfo.showGuidelines ==3">
                      <li>
                        <p class="flex align-cen">
                            <span>考试次数：</span>
                            <span class="mft">{{shouInfo(ExamPreviewInfo.answerNumType,ExamPreviewInfo.answerNum,1)}}</span>
                        </p>
                    </li>
                    <li>
                        <p class="flex align-cen">
                            <span>考试限时：</span>
                            <span class="mft">{{shouInfo(ExamPreviewInfo.answerTimeControl,'',2)}}</span>
                        </p>
                    </li>
                    <li>
                        <p class="flex align-cen">
                            <span>及格分数：</span>
                            <span class="mft">{{shouInfo(0,ExamPreviewInfo.passmark,3)}}</span>
                        </p>
                    </li>
                    <li>
                        <p class="flex align-cen">
                            <span>考试规则：</span>
                            <span class="mft">{{shouInfo(ExamPreviewInfo.allowBackChange,'',4)}}</span>
                        </p>
                    </li>
                    <li>
                        <p>
                            如果考试异常中断，请退出并及时按同样步骤进入，继续考试
                        </p>
                    </li>
                </ul>
                <div class="goToExam" @click="isShow = 2">
                    进入考试
                </div>
            </div>
             <div class="new-content-panel" v-if="isShow == 2" :class="$util.isMobile() ? 'new-content-panel1' : ''">
                     <div class="brand-info">
                    <div class="new-exam-title">
                        {{ExamPreviewInfo.paperName}}
                    </div>
                    <h4>请输入您的身份信息</h4>
                </div>
                <div class="form-group">
                    <div class="input-group flex align-cen">
                        <div class="label">账号</div>
                        <el-input placeholder="请输入您账号" v-model="account" clearable></el-input>
                    </div>
                    <div class="input-group flex align-cen">
                        <div class="label">密码</div>
                        <el-input placeholder="请输入您的账号密码" v-model="psw" clearable show-password></el-input>
                    </div>
                </div>
                 <el-button class="goToExam" style="margin-top:120px" @click="openListexams" :loading="loading">
                开始考试
            </el-button>
             </div>
            </div>
        </div>
    </div>
</template>
<script>
import {paperExam} from "@/api/enterprise/index"  //考试查询试卷息
import { login } from "@/api/auth/login"
import LocaStorage from "../../utils/localstorage.js"
import WaterMark from '@/utils/waterMark.js'
const token2 = LocaStorage.setAge().get('token2')
export default {
    name:'examLogin',
    data () {
        return {
            loading:false,
            account:'',
            psw:'',
            ExamPreviewInfo:{},
            isShow:1,
            businessInfo:{},
            waterMark:null
        }
    },
    created() {
          if(this.$locaStorage.setAge().get('businessInfo')){
            this.businessInfo = this.$locaStorage.setAge().get('businessInfo')
         }else{
            this.businessInfo = {
                id:this.$route.query.businessId
            }
         }
        this.getPaperExam()
    },
    mounted () {
    },

    methods: {
                  // 根据条件显示不同
        shouInfo(type,num,fnType){
            // fnType = 1 表示考试次数、 2、表示考试限时、3、及格分数，4、考试股则
            const actionTypelanes = {
                0:fnType == 1 ? '无限次': fnType == 3 ? `${num}%`: '-',
                1:fnType == 1 ? '一次' : fnType == 2 ? `${this.ExamPreviewInfo.answerTimeLimit}分钟` : fnType == 4 ? '允许考生返回修改答案' : '',
                2:fnType == 1 ? `多次（${num}次）` : fnType == 2 ? '' : '',
                3:fnType == 1 ? `每天每人（${num}）次` : fnType == 2 ? `单题${this.ExamPreviewInfo.singleDuration}分钟` : '',
                4:fnType == 1 ? '' : fnType == 2 ? '填空题' : ''
            }
            return actionTypelanes[type] || '-'
        },
        // 开始考试
        openListexams(){
              if(!this.account){
               return this.$util.Notifi('请输入账号','error','fa-exclamation-circle');
            }
             if(!this.psw){
               return this.$util.Notifi('请输入密码','error','fa-exclamation-circle');
            }
             let params = {
                 username:this.account,
                 password:this.psw
            }
            if(token2){
				localStorage.removeItem('token2')
                localStorage.removeItem('userinfo2')
			}
            this.loading = true
             login(params,3,'enterprise').then((res) => {
                this.loading = false
                if(res.access_token) {
               LocaStorage.setAge().set('token2',res.token_type + ' ' + res.access_token)
                LocaStorage.setAge().set('userinfo2',res.user_info)
                let params = {
                    id:this.$route.query.id,
                }
                const encryptQuery = this.$base64.encode(JSON.stringify(params)) //链接参数加密
                if(!this.ExamPreviewInfo.practiceMode || this.ExamPreviewInfo.practiceMode == 0){
                  this.$util.Notifi('登录成功，正在进入考试','success','fa-check')
                        setTimeout(() => {
                            if(this.$util.isMobile()){
                          this.$router.push({
                        name:'mobildDoExam',
                        query:{
                            json:encryptQuery,
                            businessId:this.businessInfo.id
                        }
                        })
                            }else{
                         this.$router.push({
                        name:'doExam',
                        query:{
                            json:encryptQuery,
                            businessId:this.businessInfo.id
                        }
                        })
                            }
                        },100);
                }else{
                     this.$util.Notifi('登录成功，正在进入练习','success','fa-check')
                        if(this.$util.isMobile()){
                             this.$router.push({
                        name:'mobilePracticeExam',
                        query:{
                            json:encryptQuery,
                            businessId:this.businessInfo.id
                        }
                        })
                        }else{
                        setTimeout(() => {
					    this.$router.push({
                        name:'practiceExam',
                        query:{
                            json:encryptQuery,
                            businessId:this.businessInfo.id
                        }
                        })
                        },100);
                        }
                }
                }else{
                  this.$util.Notifi(res.msg,'error','fa-exclamation-circle')  
                }
              
             })
             .catch(err =>{
                this.loading = false
             })

        },
        getPaperExam(){
            paperExam({id:this.$route.query.id,view:'start'}).then(res=>{
              if(res.code == 0){
                this.ExamPreviewInfo = res.data
                document.title = this.ExamPreviewInfo.paperName
              }else{
                this.$util.Notifi(res.msg,'error','fa-exclamation-circle')
                setTimeout(() => {
					    this.$router.push('/myExam/testingCenter')
                        },1000);
              }
               
            })
        },
    },
}
</script>
<style lang="scss" scoped>
.publicViewClass{
    overflow-x: hidden;
}
 .new-content-panel1{
    width: auto !important;
     margin: 20px auto 0 !important;
     .form-group{
         .input-group{
            padding: 0px !important;
         }
     }
 }
 .new-content-panel{
    width: 600px;
    margin: 70px auto 0;
    float: none;
    display: table;
    position: relative;
    text-align: center;
    min-height: 660px;
    background: #fff;
    padding: 30px;
    padding-top: 20px;
    padding-bottom: 100px;
    border: 1px solid #eee;
    border-radius: 10px;
    box-shadow: 0 4px 8px 0 rgba(7,17,27,.1);
    .form-group{
        .input-group{
            padding: 0 70px;
            margin-bottom: 40px;
            .label{
              border: none;
              width: 80px;
            text-align: left;
            font-size: 16px;
            color: #666;  
            }
            .el-input{
                margin-left: 10px;
            }
        }
    }
    .title{
       padding-bottom: 40px;
        margin-top: 40px;
        border-bottom: 1px solid #e6e6e6;
        text-align: center; 
        img{
            max-height: 100px;
            max-width: 100%;
        }
    }
    .brand-info{
        text-align: center;
        .new-exam-title{
       margin-top: 30px;
        font-size: 22px;
        color: #36aafd!important;
        }
        h4{
            margin: 35px 0 45px;
            color: #555;
            font-size: 18px;
            font-weight: 400;
        }
    }
    .system-introduce{
    list-style: none;
    padding: 0;
    margin: 10px auto 50px;
    max-width: 388px;
    li{
     overflow: hidden;
    border-bottom: 1px solid #f0f0f0;
    padding-bottom: 5px;
    padding-top: 5px;
    font-size: 16px;
    color: #666;
    text-align: left;
    span{
        margin-top: 3px;
        color: #333;
        font-size: 16px;
    }
    }
    }
    .goToExam{
        width: 250px;
        margin-bottom: 20px;
    color: #fff;
    background-color: #36aafd;
    padding-top: 10px;
    padding-bottom: 10px;
    border-color: #36aafd;
    border-radius: 2px;
        display: inline-block;
    padding: 6px 12px;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.42857143;
    white-space: nowrap;
    vertical-align: middle;
    -ms-touch-action: manipulation;
    touch-action: manipulation;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    background-image: none;
    border: 1px solid transparent;
    }
    }
</style>